import React from 'react';
import VerticalStack from 'Components/ComponentLibrary/Atoms/Layout/VerticalStack';
import StackItem from 'Components/ComponentLibrary/Atoms/Layout/StackItem';
import { useCommentLayoutContext } from '../../../../../CommentLayoutProvider';
import CommentsHeader from '../../../../../Components/CommentsHeader';
import MessageListPicker from '../../../../../Components/MessageListPicker';
import Footer from './Footer';

const ThreadTemplate = () => {
  const { threadResource } = useCommentLayoutContext();

  return (
    <VerticalStack height={'screen'}>
      <StackItem unshrinkable position={'top'}>
        <CommentsHeader />
      </StackItem>
      <StackItem fillsSpace scrollable>
        <VerticalStack>
          <StackItem fillsSpace />
          <MessageListPicker threadResource={threadResource} />
        </VerticalStack>
      </StackItem>
      <StackItem position={'bottom'} unshrinkable>
        <Footer />
      </StackItem>
    </VerticalStack>
  );
};

export default ThreadTemplate;
